// extracted by mini-css-extract-plugin
export default {"columns":"style_columns__h3c7y","column":"style_column__f5pwt"};